import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { isDirectAccessProvider } from '@lyrahealth-inc/shared-app-logic/src/features/providers/utils'
import { ProviderUser } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'

type MessengerEmptyViewProps = {
  user?: ProviderUser
}

const Container = styled.View({
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
})

const TextSecondary = styled(BodyText)<{ theme: ThemeType }>(({ theme }) => ({
  marginTop: theme.spacing['4px'],
}))

const MessengerEmptyView: React.FC<MessengerEmptyViewProps> = ({ user }) => {
  const theme = useTheme()

  return (
    <Container>
      <BodyText
        size={BodyTextSize.LARGE}
        color={theme.colors.textSecondary}
        textAlign='center'
        text={
          <FormattedMessage
            defaultMessage='No conversation selected'
            description='Text to show when no conversation is selected'
          />
        }
      />
      {isDirectAccessProvider(user) && (
        <TextSecondary
          size={BodyTextSize.DEFAULT}
          color={theme.colors.textSecondary}
          textAlign='center'
          text={
            <FormattedMessage
              defaultMessage='Lyra suggests responding to client messages within 2 days or less.'
              description='Text to explain the importance of responding to client messages in a timely manner'
            />
          }
        />
      )}
    </Container>
  )
}

export default MessengerEmptyView
